import axios from 'axios';
import Cookies from 'js-cookie';

/**
 * base instance and global settings for axios
 * @type {Object}
 */
const api = axios.create({
  baseURL: import.meta.env.VITE_INSIGHTS_ENDPOINT,
  headers: {
    'Content-Type': 'application/json',
  },
  transformRequest: [
    (data, headers) => {
      headers['X-CSRFToken'] = Cookies.get('csrftoken2');
      return JSON.stringify(data);
    },
  ],
});

export default api;
